import {Component, Input, OnInit} from '@angular/core';
import {SearchContactPage} from '../../modals/search-contact/search-contact.page';
import {ModalController} from '@ionic/angular';
import {ContactModel} from '../../models/contact.model';
import {DocumentModel} from '../../models/document.model';
import {CallContactService} from '../../services/call-contact.service';

@Component({
    selector: 'contactdetails',
    templateUrl: './contactdetails.component.html',
    styleUrls: ['./contactdetails.component.scss'],
})
export class ContactdetailsComponent implements OnInit {

    @Input() document: DocumentModel;

    constructor(private modalController: ModalController,
                public callContact: CallContactService) {
    }

    ngOnInit() {
        if (!this.document.contact) {
            this.document.contact = new ContactModel();
        }
    }

    async openModalSearch() {
        const modal = await this.modalController.create({
            component: SearchContactPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.document.contact = dataReturned.data;
            }
        });
        return await modal.present();

    }
}
